import React from 'react';
import {Typography, withStyles} from '@material-ui/core';
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import Toolbar from '../../components/Toolbar/Toolbar';
import CostCenterList from '../../components/CostCenter/CostCenterList';
import Paper from '@material-ui/core/Paper';

const CostCenterIndex = ({classes}) => {


    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('config.cost_center.self_plural')}
                subtitle={''}
                items={[
                    // {
                    //     icon: 'add',
                    //     text: i18n.get('project.status_form.add'),
                    //     href: `/project/create`,
                    // },
                ]}
            />

            <Paper className={classes.paper}>
                <CostCenterList/>
            </Paper>



        </Layout>
    );
};

const styles = theme => ({
    span: {
        display: 'inline',
        margin: '0 5px',
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(CostCenterIndex);
